import React from "react";
import Card from "./Card";

const staffData = [
  {
    name: "Dr. Zubair Hanif Sorathia",
    scope: "M.S (Orthopaedics)",
    timings: ["10 am to 2 pm", "6 pm to 9 pm"],
    hasImage: true,
    image: "images/dr-zubair.jpg"
  },
  {
    name: "Dr. Mahera Zubair Sorathia",
    scope: "M.B.B.S, D.M.R.E, (Radiologist)",
    timings: ["12 pm to 3 pm"]
  },
  {
    name: "Dr. Santosh Sahu",
    scope: "DNB General Surgery",
    timings: ["By Appointment"]
  },
  {
    name: "Dr. Prashant Sukharam Rane",
    scope: "MD (General Medicine)",
    timings: ["11:30 am to 1:30 pm"]
  },
  {
    name: "Dr. Geoferry Vaz",
    scope: "M.D (Skin Specialist)",
    timings: ["Monday & Wednesday 12 pm to 1 pm", "Friday 7 pm to 9 pm"]
  },
  {
    name: "Dr. Archana Mayekar",
    scope: "M.D (Gynaecologist & Laparoscopy)",
    timings: ["1:30 pm to 3:30 pm"]
  },
  {
    name: "Dr. Akshay Kothari",
    scope: "M.B.B.S, MUM (D. Diabetology)",
    timings: ["4 pm to 6 pm"]
  },
  {
    name: "Dr. Keerthic Sreevathsow",
    scope: "M.B.B.S, D.P.M (Pyschiatrist)",
    timings: ["Tuesday, Thursday, Saturday 9 am to 11 am"]
  },
  {
    name: "Dr. Snehal Panchal",
    scope: "M.D , D.N.B. (Pain Management Consultant)",
    timings: ["By Appointment"]
  }
];

const Staff = () => {
  return (
    <section className="section -mb-6 mt-4 bg-main md:p-12 relative m-auto lg:px-6 ">
      <h1 className="secondary-heading text-white mb-8 text-center xl:py-2">
        Specialists
      </h1>
      <section
        id="staff"
        // className="grid grid-cols-1 grid-flow-row gap-1 md:gap-3 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5"
        className="flex flex-row flex-wrap md:flex-col staff-container"
      >
        {staffData.map((staff) => (
          <>
            <Card
              title={staff.name}
              classNames="h-min flex-auto md:w-auto staff-card bg-gray-100 p-4 pl-6 shadow-lg m-2 rounded-tl-2xl rounded-br-2xl sm:flex sm:flex-row md:flex-initial"
              contentItems={[
                staff.scope,
                ...staff.timings.map((time) => "Available " + time)
              ]}
              titleClassNames="text-lg -ml-5 mt-2 text-main 2xl:text-2xl"
              contentClassNames="mt-0 text-md text-main 2xl:text-xl"
              imageURI={staff.hasImage ? staff.image : ""}
            />
          </>
        ))}
      </section>
    </section>
  );
};

export default Staff;
